/**
 * Helpers del email con el enlace de la videollamada (POST /ventas/meet-email).
 *
 * El regex es el MISMO que valida el backend (`v_sendMeetEmail/meetEmailTemplate.js`):
 * si divergen, el closer ve el campo en verde y el envío falla con 400.
 */

const MEET_URL_RE = /^https:\/\/meet\.google\.com\/[a-z]{3}-[a-z]{4}-[a-z]{3}(\?[^\s]*)?$/i;

export function isValidMeetUrl(url) {
  return typeof url === "string" && MEET_URL_RE.test(url.trim());
}

export function isValidEmail(value) {
  return typeof value === "string" && /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(value.trim());
}

const ERRORES = {
  meet_url_invalido:
    "Ese enlace no parece de Google Meet. Debe ser https://meet.google.com/xxx-xxxx-xxx",
  email_invalido: "Revisa el correo del destinatario.",
  email_send_failed: "No se pudo enviar el correo. Inténtalo de nuevo en un momento.",
  Forbidden: "Tu usuario no puede enviar este correo.",
  Unauthorized: "Tu sesión ha caducado. Vuelve a entrar.",
};

export function meetEmailErrorMessage(err) {
  const code = err?.response?.data?.error;
  return ERRORES[code] || "No se pudo enviar el correo. Inténtalo de nuevo.";
}
